module.exports = __webpack_public_path__ + "static/media/Categoria2Pintura.66f9a666.jpg";